<template>
  <v-layout row wrap >
    <v-flex xs12 class="text-xs-center mb-2">
      <!-- Blocked -->
      <BoardBlocked 
        v-if="match.isBlocked && match.adminMode && match.displaySets" />
      <!-- Score -->
      <BoardScore 
        :match="match" 
        :last-event="lastEvent"
        :extra-players="extraPlayers"
        :time-value="timeValue"
        :reverse="reverse"
        class="mb-1" 
        @scoreClicked="scoreClicked" />
      <!-- Panel -->
      <BoardPanel 
        :match="match"
        :mode="mode"
        :modes="modes"
        :mode-point-controls="modePointControls"
        :extra-players="extraPlayers"
        :action="action"
        :dialog-change="dialogChange"
        :change-players="changePlayers"
        :reverse="reverse"
        @toogleMode="toogleMode"
        @onAddPlayer="addPlayerNum"
        @onSetAction="setAction"
        @onSendEvent="sendEvent"
        @onChangePlayer="changePlayer"/>
      <template v-if="match.displayStats && !match.hideMenu">
        <BoardInfo :match="match" />
      </template>
      <!-- End -->
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import DateHelper from '@/lib/DateHelper'
import MatchCharts from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/MatchCharts'
import BoardBlocked from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/BoardBlocked'
import BoardPanel from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/BoardPanel'
import BoardScore from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/BoardScore'
import BoardInfo from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/BoardInfo'
import BasicStats from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/Stats/BasicStats'
import PlayerStats from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/Stats/PlayerStats'
import Leyend from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/Leyend'
import Summary from '@/components/Dashboard/Views/Club/Views/WeekMatches/Views/Match/Templates/MatchCard/MatchBoard/Board/Summary'
const debug = require('debug')('OD::Board')

export default {
  name: 'Board',
  components: {
    BoardBlocked,
    BoardPanel,
    BoardScore,
    MatchCharts,
    BasicStats,
    BoardInfo,
    PlayerStats,
    Leyend,
    Summary,
  },
  props: {
    match: {
      type: Object,
      required: true,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modes: ['basic', 'advanced', 'pro'],
      extraPlayers: ['E', '?', '-'],
      timer: null,
      timeValue: '00:00',
      lastEvent: null,
      lastEventTimeout: null,
      action: {
        team: null,
        control: null,
        player: null,
        extraPlayer: null,
      },
      dialogChange: false,
    }
  },
  computed: {
    ...mapState({
      mode: state => state.global.boardMode,
      style: state => state.style.style,
    }),
    changePlayers() {
      if (this.action.team && this.action.control && this.action.control.action === 'change') {
        const players = []
        const alreadyPlayer =
          this.action.team === 'l' ? this.match.setLocalPlayer : this.match.setVisitorPlayer
        for (let index = 1; index <= this.match.maxPlayerNum; index++) {
          if (!alreadyPlayer.find(item => item.num === index)) {
            players.push(index)
          }
        }
        return players
      }
      return []
    },
    modePointControls() {
      return this.mode === 'basic' ? this.match.pointBasicControls : this.match.pointControls
    },
  },
  watch: {
    match() {
      debug('WATCH set')
      // this.checkTimer()
      this.setLastEvent()
      if (!this.match.isLive) {
        if (this.lastEventTimeout) {
          clearTimeout(this.lastEventTimeout)
        }
      }
    },
  },
  created() {
    // this.startTimer()
  },
  beforeDestroy() {
    // this.stopTimer()
  },
  methods: {
    addPlayerNum({ team, player }) {
      this.$emit('onAddPlayer', {
        team,
        player,
      })
    },
    cleanAction() {
      this.action = {
        team: null,
        control: null,
        player: null,
        extraPlayer: null,
      }
    },
    setAction({ action, data, team }) {
      debug('setAction', { action, data, team })
      switch (action) {
        case 'player':
          debug('setAction', 'PLAYER')
          debug('aa', this.action, data)
          if (this.action.player && data && this.action.player.num === data.num) {
            this.action.control = null
            this.action.player = null
            this.action.extraPlayer = null
            this.action.team = null
          } else {
            if (this.action.player !== null) {
              this.action.control = null
            }
            this.action.player = data
            this.action.team = team
          }
          break
        case 'action':
          debug('setAction', 'ACTION')
          if (this.action.control === data) {
            this.action.player = null
            this.action.extraPlayer = null
          } else {
            this.action.control = data
          }
          break
        case 'change':
          debug('setAction', 'CHANGE')
          this.action.extraPlayer = data
          break
        default:
          debug('setAction', 'DEFAULT')
          break
      }
      const needExtraPlayer = typeof data === 'object' && data.needExtraPlayer
      if (needExtraPlayer) {
        this.dialogChange = true
      }
      debug(
        'setAction',
        'PRE',
        !needExtraPlayer || (needExtraPlayer && this.action.extraPlayer !== null),
        needExtraPlayer,
        this.action
      )
      if (
        this.action.team !== null &&
        this.action.control !== null &&
        this.action.player !== null &&
        (!needExtraPlayer || (needExtraPlayer && this.action.extraPlayer !== null))
      ) {
        debug('setAction', '--PROCESS--')
        this.$emit('onSendEvent', {
          data: this.action.control,
          team: this.action.team,
          player: this.action.player,
          extraPlayer: this.action.extraPlayer,
        })
        this.cleanAction()
      }
    },
    changePlayer({ player }) {
      debug('changePlayer', player)
      if (!this.extraPlayers.includes(this.action.player.num)) {
        debug('YYY', 'entro')
        this.$emit('onAddPlayer', { team: this.action.team, player: this.action.player })
        this.$emit('onAddPlayer', { team: this.action.team, player })
      }
      this.setAction('change', player)

      this.dialogChange = false
    },
    toogleMode(mode) {
      debug('toogleMode', mode)
      this.$store.dispatch('global/setBoardMode', { mode })
    },
    getScoreColor(team) {
      if (this.match.isFinish) {
        if (this.match.totalScoreLocal === this.match.totalScoreVisitor) {
          return 'light-green'
        }
        if (team === 'l') {
          return this.match.totalScoreLocal > this.match.totalScoreVisitor ? 'green' : 'grey'
        }
        return this.match.totalScoreVisitor > this.match.totalScoreLocal ? 'green' : 'grey'
      }
      return 'grey'
    },
    setLastEvent() {
      clearTimeout(this.lastEventTimeout)
      const set = this.match.sets[this.match.setNumber - 1]
      if (set) {
        if (set.events && set.events.length > 0) {
          this.lastEvent = set.events[set.events.length - 1]
          this.lastEventTimeout = setTimeout(() => {
            this.lastEvent = null
          }, 60000)
        } else {
          if ((!set.events || set.events.length === 0) && this.match.setNumber > 0) {
            const setAux = this.match.sets[this.match.setNumber - 2]
            if (setAux && setAux.events && setAux.events.length > 0) {
              this.lastEvent = setAux.events[setAux.events.length - 1]
              this.lastEventTimeout = setTimeout(() => {
                this.lastEvent = null
              }, 60000)
            }
          }
        }
      }
    },
    checkTimer() {
      debug('checkTimer')
      if (this.match.type === 'timeBase') {
        const set = this.match.sets[this.match.setNumber - 1]
        if (set.events) {
          debug('checkTimer', {
            a: set.events[set.events.length - 1] ? set.events[set.events.length - 1].action : null,
            t: this.timer,
          })
          if (this.timer === null) {
            if (
              set.events[set.events.length - 1] &&
              set.events[set.events.length - 1].action !== 'stop'
            ) {
              this.startTimer()
            }
          }
        }
      }
    },
    startTimer() {
      debug('startTimer')
      if (
        this.match.type === 'timeBase' &&
        this.match.sets[this.match.setNumber - 1].events &&
        this.match.sets[this.match.setNumber - 1].events.length > 0
      ) {
        debug('startTimer')
        this.timer = setInterval(() => {
          debug('updating ticker', this.set)
          const set = this.match.sets[this.match.setNumber - 1]
          if (set.events && set.events.length > 0) {
            const ini = set.events[0].when
            let last = null
            if (set.events && set.events[set.events.length - 1].action === 'stop') {
              last = set.events[set.events.length - 1].when
              this.stopTimer()
            }
            this.timeValue = DateHelper.getDatesDiffString(ini, last)
          } else {
            this.stopTimer()
          }
        }, 1000)
      }
    },
    stopTimer() {
      if (this.match.type === 'timeBase') {
        debug('stopTimer')
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }
      }
    },
    scoreClicked() {
      this.$emit('scoreClicked')
    },
    sendEvent({ data, team }) {
      if (data.action === 'remove') {
        this.$emit('onRemoveEvent', {})
        this.cleanAction()
      } else {
        this.$emit('onSendEvent', { data, team })
      }
    },
    getCustomColor(item, team) {
      return item.disabled[team] ? '#aaa' : item.color
    },
    toggleNavigation(type) {
      switch (type) {
        case 'leyend':
          this.showRighNavigation = !this.showLeyend
          this.showLeyend = !this.showLeyend
          this.showSetStats = false
          this.showPlayerStats = false
          this.showGraphStats = false
          break
        case 'setStats':
          this.showRighNavigation = !this.showSetStats
          this.showLeyend = false
          this.showSetStats = !this.showSetStats
          this.showPlayerStats = false
          this.showGraphStats = false
          break
        case 'playerStats':
          this.showRighNavigation = !this.showPlayerStats
          this.showLeyend = false
          this.showSetStats = false
          this.showPlayerStats = !this.showPlayerStats
          this.showGraphStats = false
          break
        case 'graphStats':
          this.showRighNavigation = !this.showGraphStats
          this.showLeyend = false
          this.showSetStats = false
          this.showPlayerStats = false
          this.showGraphStats = !this.showGraphStats
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
  .xs-d-block {
    display: block;
  }
}
.logo-container {
  max-width: 100%;
  overflow-y: hidden;
  display: block;
  img {
    max-height: 40px;
  }
}
.uppercase {
  text-transform: uppercase;
}

.team-name {
  text-transform: uppercase;
  font-weight: bold;
  color: grey;
}

.text-bigger {
  font-size: 1.3em;
  font-weight: bold;
}

.tiebreak-icon {
  width: 20px;
}

.blink_me {
  animation: blinker 3s linear infinite;
}

.blink_me_color {
  animation: blinker_color 3s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0.4;
  }
}

@keyframes blinker_color {
  50% {
    color: #aaa;
  }
}

.sets-summary {
  th {
    padding: 0 5px;
    background-color: #ddd;
  }
  th.white {
    background-color: #fff;
  }
  td {
    background-color: #f8f8f8;
    text-align: center;
  }
  th.odd,
  td.odd {
    background-color: #f0f0f0;
  }
  th.even,
  td.even {
    background-color: #f8f8f8;
  }
  td.bold {
    font-weight: bold;
  }
}

.table-responsive {
  display: block;
  width: 100%;
  border: 0;
  overflow-x: scroll;
  overflow-y: hidden;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  -webkit-overflow-scrolling: touch;
}

.card__text.small {
  padding: 8px 3px 3px 3px;
}

.rightPanel {
  text-align: left;
  padding: 24px;
}
</style>
